import { Auth } from '@aws-amplify/auth'

export const isSAE = async function () {
  try {
    const data = await Auth.currentAuthenticatedUser()

    if (data.getUsername().startsWith('Google_')) { // Returning false for google sso users
      return false
    }

    // TODO check if all SAE usernames start with SAE_ and amend the condition below accordingly
    const identities = data.getSignInUserSession().getIdToken().payload.identities
    return identities ? !!identities.length : false
  } catch (e) {
    return false
  }
}
